import { getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from '@tanstack/react-table'
import React, { useState } from 'react'
import TanStackTable from '../../../../../components/tables/TanStackTable'
import purchaseReportDetailsData from './purchaseReportAccountDetailsData'
import { columnSum, formatCurrency } from '../../../../../utils/tableFuncs'

const columns = purchaseReportDetailsData()

type PurchaseReportAccountDetailsProps = {
  data: any
  isLoading?: boolean
}
function PurchaseReportAccountDetails({ data, isLoading }: PurchaseReportAccountDetailsProps) {
  const [sorting, setSorting] = useState<SortingState>([])

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  const footerData = {
    amountincVAT: isNaN(columnSum(data, 'amountincVAT'))
      ? formatCurrency(0)
      : formatCurrency(columnSum(data, 'amountincVAT')),
  }

  return <TanStackTable table={table} isLoading={isLoading} footerData={footerData} />
}

export default PurchaseReportAccountDetails
